const state = {
    types: [],
    events: [],
    timeSlots: [],
    appointments: [],
    selectedEventUid: null,
    rappels: []
}


const getters = {
    types: state => state.types,
    events: state => state.events,
    timeSlots: state => state.timeSlots,
    appointments: state => state.appointments,
    selectedEventUid: state => state.selectedEventUid,
    rappels: state => state.rappels
}

const mutations = {
    SET_TYPES: (state, list) => {state.types  = list},
    ADD_TYPE: (state, type) => {state.types.push(type)},
    UPDATE_TYPE: (state, type) => {state.types = state.types.filter(item => item.uid !== type.uid); state.types.push(type)},
    DELETE_TYPE: (state, type) => {state.types = state.types.filter(item => item.uid !== type.uid)},

    SET_EVENTS: (state, list) => {state.events = list},
    ADD_EVENT: (state, event) => {state.events.push(event)},
    UPDATE_EVENT: (state, event) => {
        state.events = state.events.filter(item =>item.uid !== event.uid); 
        console.log(state.events.length)
        state.events.push(event)
        console.log(state.events.length)
    },
    DELETE_EVENT: (state, event) => {state.events = state.events.filter(item => item.uid !== event.uid)},
    DELETE_ALL_EVENTS:(state) => {state.events = []},

    SET_SELECTED_EVENT_UID: (state, uid) => {state.selectedEventUid = uid},

    SET_TIME_SLOTS: (state, list) => {state.timeSlots = list},
    ADD_TIME_SLOT: (state, slot) => {state.timeSlots.push(slot)},
    UPDATE_TIME_SLOT: (state, slot) => {state.timeSlots = state.timeSlots.filter(item => item.uid !== slot.uid); state.timeSlots.push(slot)},
    DELETE_TIME_SLOT: (state, slot) => {state.timeSlots = state.timeSlots.filter(item => item.uid !== slot.uid)},

    SET_APPOINTMENTS: (state, list) => {state.appointments = list},
    ADD_APPOINTMENT: (state, ap) => {state.appointments.push(ap)},
    UPDATE_APPOINTMENT: (state, ap) => {state.appointments = state.appointments.filter(item => item.uid !== ap.uid); state.appointments.push(ap)},
    DELETE_APPOINTMENT: (state, ap) => {state.appointments = state.appointments.filter(item => item.uid !== ap.uid)},

    SET_RAPPELS: (state, list) => {state.rappels = list},
    ADD_RAPPEL: (state, rap) => {state.rappels.push(rap)},
    UPDATE_RAPPEL: (state, rap) => {state.rappels = state.rappels.filter(item => item.uid !== rap.uid); state.rappels.push(rap)},
    DELETE_RAPPEL: (state, rap) => {state.rappels = state.rappels.filter(item => item.uid !== rap.uid)},

}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}